import React from 'react';

import IconNiftyDoc from 'icons/icon-nifty-doc';
import IconGoogleDocument from 'icons/icon-google-document';
import IconGoogleSpreadsheets from 'icons/icon-google-spreadsheets';
import IconGooglePresentation from 'icons/icon-google-presentation';
import IconMSWord from 'icons/icon-ms-word';
import IconMSExcel from 'icons/icon-ms-excel';
import IconMSPowerPoint from 'icons/icon-ms-power-point';

const DocIcon = ({ type, subtype, size }) => {
    if (type === 'google') {
        if (subtype === 'document') {
            return <IconGoogleDocument size={size} />;
        }

        if (subtype === 'spreadsheet') {
            return <IconGoogleSpreadsheets size={size} />;
        }

        if (subtype === 'presentation') {
            return <IconGooglePresentation size={size} />;
        }
    }

    if (type === 'microsoft') {
        if (subtype === 'document') {
            return <IconMSWord size={size} />;
        }

        if (subtype === 'spreadsheet') {
            return <IconMSExcel size={size} />;
        }

        if (subtype === 'presentation') {
            return <IconMSPowerPoint size={size} />;
        }
    }

    return <IconNiftyDoc size={size} />;
}

export default DocIcon;
